import axios from 'axios';

export class BusinessReviewsService {
    async fetchAll(page = 0, limit = 20, search = '') {
        return (await axios.get('/business-review?page=' + page + '&limit=' + limit + '&search=' + search)).data;
    }

    async fetchOne(id) {
        return (await axios.get('/business-review/' + id)).data;
    }

    async update(id, item) {
        return (await axios.patch('/business-review/' + id, item)).data;
    }

    async create(item) {
        return (await axios.post('/business-review', item)).data;
    }
    async delete(item) {
        return (await axios.delete('/business-review/' + item._id)).data;
    }
}